export enum THEME_NAMES {
  DEFAULT = 'Default',
  NEW = 'New',
  BARBIE = 'Barbie',
  DARK = 'Dark',
  SYSTEM = 'System',
}
